<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import questionnaire from './../libs/questionnaire.json';
  import { attachScores } from './../libs/utils.js';
  
  import Footer from "./../components/Footer.svelte";

  export let id;

  let sections = attachScores(questionnaire, id);

  let percentages = sections.map(el => el.pct)
  let overall_pct = Math.round( summation(percentages) / percentages.length )

  function summation(array) {
      return array.reduce((tot, el) => tot + el, 0)
  }

  function pct2index(pct) {
    let index;
    if (pct <= 20) index = 0;
    else if (pct <= 50) index = 1;
    else if (pct <= 84) index = 2;
    else index = 3;

    return index;
  }

  let lead = [
    $_('results.bad_lead'),
    $_('results.low_lead'),
    $_('results.good_lead'),
    $_('results.great_lead')
  ]

  let descriptions = [
    $_('results.bad_desc'),
    $_('results.low_desc'),
    $_('results.good_desc'),
    $_('results.great_desc')
  ]

  let trail = [
    $_('results.bad_trail'),
    $_('results.low_trail'),
    $_('results.good_trail'),
    $_('results.great_trail')
  ]

  let prg_classes = [
    'progress-error',
    'progress-warning',
    'progress-info',
    'progress-success'
  ]

</script>

  <div>
  <div class="hero py-16" style="background-image: url('/assets/pexels-adrien-olichon-3137058.jpg');">
    <div class="hero-content text-center w-full mx-8 lg:w-2/5">
      <div class="w-full">
        <h1 class="text-5xl font-bold">Business2030</h1>
        <p class="py-6"> {$_('results.subtitle')} </p>

        <br>

        <div class="card shadow-xl bg-base-100">
            <div class="card-body text-center">
              <progress class="progress {prg_classes[ pct2index(overall_pct) ]} w-full" value="{overall_pct}" max="100"></progress>
              <h2 class="card-title block mt-8"> {$_('results.overall')}: &#8194; {overall_pct}/100 </h2>
              <div class="divider"></div>
              <div class="justify-around">
                <p class="text-justify leading-loose"> {$_(lead[ pct2index(overall_pct) ], { values: { score: overall_pct + '/100' } })} </p><br>
                <p class="text-justify leading-loose"> {$_(descriptions[ pct2index(overall_pct) ])} </p><br>
                <p class="text-justify leading-loose"> {$_(trail[ pct2index(overall_pct) ])} </p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- content -->
  <div class="container my-8 mx-auto w-4/5 flex flex-wrap justify-around">
    {#each sections as section}

        <div class="card overflow-visible basis-96 shadow-xl sm:mx-4 my-6 bg-neutral-content">
          <div class="card-body text-center">
            <h2 class="card-title block mt-0 mb-4 text-neutral"> {$_(section.section)} </h2>
            <div class="flex items-baseline justify-around">

              {#if section.pct < 60}
                <div class="radial-progress mr-8 font-bold text-error" style="--thickness: 5px; --value:{section.pct};">{section.pct}%</div>

                <div class="tooltip" data-tip="{$_('results.ko_desc', { values: { score: section.pct + '/100' } })}">
                  <button class="btn btn-active btn-error">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-neutral-content" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-25.3-19.5-46-44.3-47.9c7.7-8.5 12.3-19.8 12.3-32.1c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 320H96c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64V288c0 17.7 14.3 32 32 32z"/></svg>
                  </button>
                </div>
              {:else}
                <div class="radial-progress mr-8 font-bold text-success" style="--thickness: 5px; --value:{section.pct};">{section.pct}%</div>

                <div class="tooltip" data-tip="{$_('results.ok_desc', { values: { score: section.pct + '/100' } })}">
                  <button class="btn btn-active btn-success">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-neutral-content" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 25.3-19.5 46-44.3 47.9c7.7 8.5 12.3 19.8 12.3 32.1c0 23.4-16.8 42.9-38.9 47.1c4.4 7.2 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"/></svg>
                  </button>
                </div>
              {/if}

            </div>
          </div>
        </div>

    {/each}

  </div>

  <Footer/>

</div>

